import { getBackgroundUrl, getUiVersion, getTwitchStatus, getServerStatus } from './data'

// Reducer is exposed so that we can hook it up to the store creation
export { default as syncReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Selectors are exposed to give other parts of the code read access of the feature state
export const selectors = {
    getBackgroundUrl, // Used by MainSection container
    getUiVersion, // Used by SideMenu container
    getTwitchStatus, // Used by SideMenu container
    getServerStatus, // Used by ServerMenu feature
}



// WEBPACK FOOTER //
// ./src/features/Sync/exports.js